import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import fastCarWithDone from "../../../../assets/svgs/fast-car-with-done.svg";

interface AcknowledgedProps {}

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: "#001234",
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    justifyContent: "center",

    "@media (max-width: 600px)": {
      width: 320,
      margin: "auto",
    },
  },
  label: {
    fontSize: 26,
    fontWeight: 500,
    fontFamily: "lato",
    color: "white",
    lineHeight: "normal",
    maxWidth: 660,

    "@media (max-width: 600px)": {
      fontSize: 17,
    },
  },
  carIcon: {
    marginBottom: 30,
    paddingRight: 40,
    width: 190,

    "@media (max-width: 600px)": {
      width: 140,
    },
  },
}));

const Acknowledged: React.FC<AcknowledgedProps> = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <img src={fastCarWithDone} className={classes.carIcon} />
      <div className={classes.label}>Our team has acknowledged your callout and will be with you as soon as possible.</div>
    </div>
  );
};

export default Acknowledged;
